// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.lease.LeaseOuidWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetLeaseResponseDto, GetLeaseV2ResponseDto } from '../..';

interface GetLeaseFromOuidParams {
  ouid: string;
}
interface GetLeaseFromOuidV2Params {
  ouid: string;
}

export const LeaseOuidWebApiHandler_getLeaseFromOuid_Path = '/api/web/v1/ouid/getLeaseFromOuid';

/**
 * get lease from ouid
 */
export const LeaseOuidWebApiHandler_getLeaseFromOuid = (getParams: GetLeaseFromOuidParams, client = getClient()) => {
  return httpFrontEndRequest<GetLeaseFromOuidParams, never, GetLeaseResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseOuidWebApiHandler_getLeaseFromOuid_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseOuidWebApiHandler_getLeaseFromOuidV2_Path = '/api/web/v1/ouid/getLeaseFromOuidV2';

/**
 * get lease from ouid
 */
export const LeaseOuidWebApiHandler_getLeaseFromOuidV2 = (
  getParams: GetLeaseFromOuidV2Params,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetLeaseFromOuidV2Params, never, GetLeaseV2ResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseOuidWebApiHandler_getLeaseFromOuidV2_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
